import CalendarioEmpleadoImpl from 'components/calendario/CalendarioEmpleadoImpl'
import React from 'react'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'

const ViewEmpleadoCalendario = () => {
  return (
    <>
        <Row>
            <Col>
                <Card>
                    <CardHeader>
                      Calendario personal:
                    </CardHeader>
                    <CardBody>
                    <CalendarioEmpleadoImpl></CalendarioEmpleadoImpl>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    </>
  )
}

export default ViewEmpleadoCalendario